import React from "react";
import AddBooking, { AddBookingType } from "../AddBooking/AddBooking";

export const DiaryAddBookingSection = ({
  prefillBookingType,
  setPrefillBookingType,
  setShowAddBooking
}: AddBookingType) => {
  return (
    <div className="DiaryAddBookingSection h-full w-[var(--sidebarWidth)] shadow-[2px_-2px_5px_-2px_var(--borderColor)]">
      <AddBooking
        setShowAddBooking={setShowAddBooking}
        prefillBookingType={prefillBookingType}
        setPrefillBookingType={setPrefillBookingType}
      />
    </div>
  );
};
